import { toast } from "react-toastify";
import { ToastCloseButton } from "./ToastCloseButton";

interface ToastMessage {
    Message: string;
}

export const WarnToast = ({ Message }: ToastMessage) => {
    toast.warn(Message, {
        toastId: Message,
        closeButton: ToastCloseButton,
        icon: () => <></>,
    });
};
